<template>
  <div class='writereport' v-loading.fullscreen.lock='fullloading'>
    <div class='writereport-header'>
      <div class='header-return'>
        <el-button type='primary' @click='returnPrev'><svg-icon  icon-class='return'></svg-icon>&nbsp;&nbsp;返&nbsp;&nbsp;&nbsp;&nbsp;回</el-button>
      </div>
      <ul class='header-father-list'>
        <li>
          <ul class='header-child-list' @click='patientDetails'>
            <li><svg-icon  icon-class='user-1'></svg-icon></li>
            <li>登记信息</li>
          </ul>
        </li>
        <li>
          <ul class='header-child-list' @click='pacsImg(printInfo.webPacsUrl)'>
            <li><svg-icon  icon-class='preview'></svg-icon></li>
            <li>影像预览</li>
          </ul>
        </li>
        <li>
           <ul class='header-child-list' @click='historyDetails'>
            <li><svg-icon icon-class='historylist'></svg-icon></li>
            <li>历史报告</li>
          </ul>
        </li>
        <!--<li>
          <ul class='header-child-list' @click='weasisImg(printInfo.weasisPacsUrl)'>
            <li><svg-icon icon-class='set-image' style="width:40px;"></svg-icon></li>
            <li>一脉影像</li>
          </ul>
        </li>
         <li>
          <ul class='header-child-list'>
            <li><svg-icon  icon-class='ai'></svg-icon></li>
            <li>辅助/AI</li>
          </ul>
        </li> -->
        <li>
          <ul class='header-child-list' @click='recordDetails'>
            <li><svg-icon  icon-class='record'></svg-icon></li>
            <li>状态记录</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class='main'>
      <el-row class='main-cont'>
        <div class='main-left' >
            <div class='left-module' style='padding-top:0px;border-bottom:1px solid #DDDDDD;' v-if='isReport === "1"'>
              <el-radio-group v-model='search.CompleteStatus' style='text-align: center;'  size='medium' @change='submit'>
                <el-radio-button  label='5'>待诊断</el-radio-button>
                <el-radio-button  label='10'>进行中</el-radio-button>
              </el-radio-group>
            </div>
            <div class='left-module' style='padding-top:0px;border-bottom:1px solid #DDDDDD;' v-if='isReport === "2"'>
              <el-radio-group v-model='search.CompleteStatus' style='text-align: center;'  size='medium ' @change='submit'>
                <el-radio-button label='25'>待审核</el-radio-button>
                <el-radio-button label='30'>审核中</el-radio-button>
              </el-radio-group>
            </div>
            <div class='left-module' style='padding:10px;'>
                <el-row :gutter='5'>
                    <el-col :lg='12' :xl='12' :span='12'>
                        <el-select size='mini' v-model='timeType' placeholder=''>
                          <el-option   v-for='item in getTime' :key='item.Value' :label='item.Text' :value='item.Value'></el-option>
                        </el-select>
                    </el-col>
                    <el-col :lg='12' :xl='12' :span='12'>
                        <el-select size='mini' v-model='search.patientType' placeholder='全部患者来源'>
                            <el-option  v-for='item in dict.patientSource' :key='item.dictName' :label='item.dictName' :value='item.dictName'></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row :gutter='5' style='margin-top:10px;'>
                    <el-col :lg='12' :xl='12' :span='12'>
                        <el-select size='mini' v-model='search.Modality' placeholder='全部设备类型' clearable >
                          <el-option  v-for='item in checkList.checkType' :key='item.name' :label='item.name' :value='item.name'></el-option>
                        </el-select>
                    </el-col>
                    <el-col :lg='12' :xl='12' :span='12'>
                        <el-select size='mini' v-model='search.bodyPart'  placeholder='全部检查部位' clearable >
                            <el-option v-for='item in checkList.checkBody' :key='item.name' :label='item.name' :value='item.name'></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row  style='margin-top:10px;'>
                    <el-col :lg='8' :xl='8' :span='8'>
                        <el-select size='mini' v-model='queryType' placeholder=''>
                            <el-option  v-for='item in getqueryType' :key='item.Value' :label='item.Text' :value='item.Value'></el-option>
                        </el-select>
                    </el-col>
                    <el-col :lg='10' :xl='10' :span='10'>
                        <el-input size='mini' class='input-border'  v-model='queryValue' placeholder='请输入内容'></el-input>
                    </el-col>
                    <el-col :lg='6' :xl='6' :span='6'>
                        <el-button :loading='loading'  type='primary' style='width: 100%;border-left:none;border-bottom-left-radius: 0px;border-top-left-radius: 0px;' size='mini' @click.native='submit'>查询</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class='left-module' style='padding-top:0px;margin-top:10px;border-top:1px solid #397EE3;'>
                <el-table stripe :data='writeReportList' size='mini'  style='width: 100%' v-loading='tableLoading' :height='tableHeight' @row-dblclick='dbTalble'>
                    <el-table-column prop='patientName' align='center' fixed='left' label='姓名' width='100px'></el-table-column>
                    <el-table-column prop='sexName' label='性别' width='50px'> </el-table-column>
                    <el-table-column prop='performNo' label='检查号' width='110px'> </el-table-column>
                    <el-table-column prop='patientNo' label='影像号' width='110px'> </el-table-column>
                    <el-table-column prop='modalityName' label='类型' width='120px'> </el-table-column>
                    <el-table-column prop='checkingItems' label='检查项目' width='180px'>
                      <template slot-scope="scope">
                          <div slot="reference" class="name-wrapper">
                            <span v-if='scope.row.checkingItems'>{{ scope.row.checkingItems | checkingItems}}</span>
                            <div v-else></div>
                          </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop='bodyParts' label='部位' width='110px'> </el-table-column>
                    <el-table-column prop='endExecDt' label='检查时间' width='135px'> </el-table-column>
                    <el-table-column prop='submitTime' label='诊断时间' width='135px'> </el-table-column>
                    <el-table-column prop='statusName' label='医疗状态' width='110px'></el-table-column>
                    <el-table-column prop='patientType' label='患者来源' width='110px'> </el-table-column>
                </el-table>
            </div>
        </div>
        <div class='main-center'  v-bind:style='{ width: centerWidth + "px", height: printHeight+1 + "px" }'  >
          <div class='center-module'  v-bind:style='{ height: printHeight + "px" }' v-loading='printLoading'>
            <div  class='div_prints'>
                <div >
                    <div  style='height:40px;line-height:40px;margin-top:20px;padding-left:10px;padding-right:10px;text-align:center;font-size: 18px;color: #0A2E5C;'>
                      <span v-if='isReport ==="1" ' style="font-size: 20px;font-weight: bold;">报告诊断</span>    
                      <span v-if='isReport ==="2" ' style="font-size: 20px;font-weight: bold;">报告审核</span>    
                    </div>
                    <div style='height:30px;line-height:30px;margin-top:20px;border-bottom:1px solid #ddd;padding-left:10px;padding-right:10px;'>
                        <span style='font-size:16px;float:left'>患者编号:{{printInfo.patientNo}}</span>
                        <span style='font-size:16px;float:right' v-if='printInfo.endExecDt'>检查日期:{{printInfo.endExecDt}}</span>
                        <span style='font-size:16px;float:right' v-else>检查日期:
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;
                        </span>
                    </div>
                    <div style='height:670px;'>
                        <div >
                            <table class='div_prints_table'>
                                <tr style='border: none;height: 28px;line-height: 28px;'>
                                    <td style='70px;'>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</td>
                                    <td style='font-weight:100;width: 150px;'>{{printInfo.patientName}}</td>
                                    <td style='70px;'>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</td>
                                    <td  style='font-weight:100;width: 150px;'>{{printInfo.sexName}}</td>
                                    <td  style='70px;'>年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;龄:</td>
                                    <td  style='font-weight:100;width: 150px;'>{{printInfo.age | ageFilter}}</td>

                                </tr>
                                <tr style='border: none;height: 28px;line-height: 28px;'>
                                    <td style='70px;'>科&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;室:</td>
                                    <td  style='font-weight:100;width: 150px;'>{{printInfo.applyDepart}}</td>
                                    <td style='70px;'>住&nbsp;&nbsp;院&nbsp;&nbsp;号:</td>
                                    <td  style='font-weight:100;width: 150px;'>{{printInfo.inPatientNo}}</td>
                                    <td style='70px;'>床&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号:</td>
                                    <td  style='font-weight:100;width: 150px;'>{{printInfo.bedNo}}</td>

                                </tr>
                                <tr style='border: none;height: 28px;line-height: 28px;'>
                                    <td style='70px;'>检查部位:</td>
                                    <td style='font-weight:100;width: 150px;'>{{printInfo.bodyParts }}</td>
                                    <td style='70px;'>检查项目:</td>
                                    <td colspan='3'  style='font-weight:100;'>{{printInfo.checkingItems}}</td>
                                </tr>
                                <tr style='border: none;height: 28px;line-height: 28px;'>
                                    <td style='70px;'>既&nbsp;&nbsp;往&nbsp;&nbsp;史:</td>
                                    <td colspan='5' style='font-weight:100;'><div style='height: 28px;overflow-y: auto;'>{{printInfo.healthHistory}}</div></td>
                                </tr>
                                <tr style='border: none;height: 28px;line-height: 28px;'>
                                    <td style='70px;'>现&nbsp;&nbsp;病&nbsp;&nbsp;史:</td>
                                    <td colspan='5' style='font-weight:100;'><div style='height: 28px;overflow-y: auto;'>{{printInfo.currentHealthHistory}}</div></td>
                                </tr>
                            </table>
                        </div>
                        <div style='padding-bottom: 25px;border-bottom:1px solid #ddd;'>
                            <div >
                                <div style='font-size:16px;height:20px;line-hegiht:20px;margin: 10px;'>检查所见</div>
                                <el-input class='writeport_image'  type='textarea' :rows='10' placeholder='请输入内容' v-model='printInfo.wys'></el-input>
                            </div>
                            <div >
                                <div style='font-size:16px;height:20px;line-hegiht:20px;margin:10px;'>诊断所得</div>
                                <el-input class='writeport_image'  type='textarea' :rows='10' placeholder='请输入内容' v-model='printInfo.wyg'></el-input>
                            </div>
                        </div>
                        <div class='div_prints_footer'>
                            <span>
                                报告医师:{{printInfo.createrName}}
                            </span>
                            <span>
                                审核医师:{{printInfo.firstApproverName}}
                            </span>
                            <span style='width:50%;text-align: right;' v-if='printInfo.submitTime'>
                                报告日期:{{printInfo.submitTime}}
                            </span>
                            <span style='width:50%;text-align: right;' v-else>
                              报告日期:
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;
                            </span>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class='main-right' >
            <div class='right-module' style='text-align: center;margin-top:0px;padding-bottom:0px;border-bottom:1px solid #DDDDDD;'>
                <el-radio-group class='right-header' v-model='modules' @change='changeTemplateType' size='mini'>
                    <el-radio-button label='GlobalTemplate'>医院模板</el-radio-button>
                    <el-radio-button label='UserTemplate'>个人模板</el-radio-button>
                </el-radio-group>
            </div>
            <div class='right-module'>
                <span class='right-title'>
                    诊断词条
                    <el-radio-group style='margin-left: 10px;' v-model='wordBar' size='mini'>
                      <el-radio label='1' >替换</el-radio>
                      <el-radio label='2' >追加</el-radio>
                    </el-radio-group>
                </span>
            </div>
            <div  class='right-module right-tree' v-bind:style='{ height: treeHeight + "px" }' v-if='!ifSelfTemplate' v-loading='treeLoading'>
                <el-input placeholder='输入关键字进行过滤' style='width:100%;padding:0px 10px;background:#f8f8f8;' size='mini' v-model='filterText'></el-input>
                <el-tree class='filter-tree' @node-click='changeTemplate' :data='templates' :props='defaultProps' node-key="templateDircId" :default-expanded-keys='defaultTree' :filter-node-method='filterNode' :render-content="renderContent" ref='tree2'></el-tree>
            </div>
            <div  class='right-module right-tree' v-bind:style='{ height: treeHeight + "px" }' v-else v-loading='treeLoading'>
                <el-input placeholder='输入关键字进行过滤' style='width:100%;padding:0px 10px;background:#f8f8f8;' size='mini' v-model='filterText'></el-input>
                <el-tree class='filter-tree' @node-click='changeTemplate' :data='templates' :props='defaultProps' node-key="templateDircId" :default-expanded-keys='defaultTree' :filter-node-method='filterNode' :render-content="renderSelfContent" ref='tree2'></el-tree>
            </div>
            <div class='right-module' style='height:280px;border-top:2px solid #dddDDD;'>
              <div class='right-title'>
                报告设置
              </div>
              <div class='right-form'>
                <el-form label-position='left' size='mini'  label-width='80px' :model='form'>
                  <el-form-item label='打印模板'>
                    <el-select v-model='reportModule' placeholder='请选择打印模板'>
                      <el-option v-for='item in printList' :key='item.templateId' :label='item.templateName' :value='item.templateId'></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label='阴阳性'>
                    <el-radio-group v-model='printInfo.isPositive'>
                      <el-radio :label='0'>阴性</el-radio>
                      <el-radio :label='1'>阳性</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label='危急值'>
                    <el-radio-group v-model='printInfo.isEmergency'>
                      <el-radio :label='0'>不上报</el-radio>
                      <el-radio :label='1'>上报</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label='诊断得分' v-if="this.printInfo.status>70">
                    <el-slider v-model="printInfo.qcScore"></el-slider>
                  </el-form-item>
                  
                </el-form>
              </div>
              <div class='right-btn' v-if='isReport === "1" '>
                <el-button v-if='printInfo.status === 60' type='warning' size='mini' :loading='loading' @click='AutoSaveReport()'>保存</el-button>
                <el-button v-if='printInfo.status === 60' type='primary' size='mini' :loading='loading' @click='SubmitReport()'>提交诊断</el-button>
                <el-button v-if='printInfo.status === 60' type='success' size='mini' :loading='loading' @click='DeleteReport()'>放弃诊断</el-button>
              </div>
              <div class='right-btn' v-if='isReport === "2" '>
                <el-button v-if='printInfo.status === 90' type='warning' size='mini' :loading='loading' @click='AutoSaveReport()'>保存</el-button>
                <el-button v-if='printInfo.status === 90' type='primary' size='mini' :loading='loading' @click='SubmitApproveReport()'>提交审核</el-button>
                <el-button v-if='printInfo.status === 90' type='success' size='mini' :loading='loading' @click='AbandonApproveReport()'>放弃审核</el-button>
                <el-button v-if='printInfo.status === 90' type='info' size='mini' :loading='loading' @click='showRejectReportDialog = true'>驳回报告</el-button>
                <el-button v-if='printInfo.status === 100' type='primary' size='mini' :loading='loading' @click='printReport()'>打印报告</el-button>
              </div>
            </div>
        </div>
      </el-row>
    </div>
    <div class="fix-btn">
      <div style="margin-bottom:20px;">
        <el-tooltip class="item" effect="dark" content="存为个人模板" placement="right">
          <el-button @click='saveTemplate = true' type='primary' round ><svg-icon  icon-class='save'></svg-icon></el-button>
        </el-tooltip>
      </div>
      <!-- <div style="margin-bottom:20px;" v-if='printInfo.status === 100 || printInfo.status === 70'>
        <el-tooltip class="item" effect="dark" content="打印预览" placement="right">
          <el-button @click='printReport()' type='primary' round><svg-icon  icon-class='print'></svg-icon></el-button>
        </el-tooltip>
      </div> -->
      <div v-if='printInfo.status === 100'>
        <el-tooltip class="item" effect="dark"  content="导出PDF" placement="right">
          <el-button style="color:#fff;" @click='printReport(printInfo.patientNo)' type='primary' round><svg-icon  icon-class='pdf'></svg-icon></el-button>
        </el-tooltip>
      </div>
    </div>
    <el-dialog class="selfEditDialog" title="新建模板" :visible.sync="saveTemplate">
      <el-form :model="saveModule" ref='saveModule' size='mini' :rules="rules">
        <el-form-item label="模板分组" prop='bodyPart' style="position:relative">
            <el-input v-model="saveModule.bodyPart" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="模板名称" prop='name'>
          <el-input v-model="saveModule.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop='modality'>
            <el-select disabled size='mini' v-model='saveModule.modality' placeholder='全部设备类型' clearable >
              <el-option  v-for='item in checkList.checkType' :key='item.name' :label='item.name' :value='item.name'></el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item label="检查部位" prop='bodyPart'>
          <el-select size='mini' v-model='saveModule.bodyPart'  placeholder='' clearable >
              <el-option v-for='item in checkList.checkBody' :key='item.name' :label='item.name' :value='item.name'></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="检查所见" prop='wys'>
          <el-input class='writeport_image'  type='textarea' :rows='5' placeholder='请输入内容' v-model='saveModule.wys'></el-input>
        </el-form-item>
        <el-form-item label="诊断所得" prop='wys'>
          <el-input class='writeport_image'  type='textarea' :rows='5' placeholder='请输入内容' v-model='saveModule.wyg'></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveTemplate = false">取 消</el-button>
        <el-button type="primary" @click="savemodule">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="驳回原因"
      :visible.sync="showRejectReportDialog"
      width="700px"
    >
      <el-row style="margin-top:20px;">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 10}"
          placeholder="请填写驳回报告的原因"
          v-model="rejectReportReason">
        </el-input>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRejectReportDialog = false">取 消</el-button>
        <el-button type="primary" @click="RejectReport">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from '@/utils/common.js'
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
export default {
  name: 'writereport',
  data() {
    return {
      loading: false, // 按钮
      fullloading: true, // 页面
      tableLoading: false, // 列表
      printLoading: false, // 打印
      treeLoading: false, // 树
      form: {}, // 模板设置无用表单不可删除
      reportModule: '', // 报告模板
      tableHeight: '100px', // 表格高度
      printHeight: '100', // 打印高度
      centerWidth: '100px', // 打印宽度
      treeHeight: '100px', // 模板高度
      modules: 'GlobalTemplate', // 模板类型
      ifSelfTemplate: false, // 是否个人模板
      wordBar: '1', // 诊断词条
      queryType: 0, // 搜索类型
      saveTemplate: false, // 模板dialog
      search: { // 搜索入参
        Status: 0,
        patientName: '',
        studyUID: '',
        RegNo: '',
        PerformNo: '',
        PatientType: '',
        SubmitterName: '',
        DateArray: [new Date(), new Date()],
        Modality: '',
        bodyPart: '',
        DepartId: '',
        PageIndex: 1,
        PageCount: 25,
        IsShowAll: 1,
        CompleteStatus: '5',
        SendTypes: [0, 1, 2],
        SrcHospitalName: ''
      },
      CreateOrUpdateReport: {// 保存更新报告
        reportId: '',
        performId: '',
        regId: '',
        wys: '',
        wyg: '',
        status: '',
        isEmergency: '',
        isPositive: '',
        procedureIds: [],
        isDeleted: '',
        departId: '',
        qcScore: 0
      },
      queryValue: '',
      timeType: 0,
      getTime: common.SettingsTime.value,
      getqueryType: common.SettingsqueryType.value,
      filterText: '',
      defaultTree: [],
      defaultProps: {
        children: 'childrenList',
        label: 'templateDircName'
      },
      saveModule: {
        templateId: '',
        hospId: '',
        departId: '',
        name: '',
        reportId: '',
        modality: '',
        bodyPart: '',
        doctorAdvice: '',
        isPositive: 0,
        gender: 0,
        wyg: '',
        wys: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        wys: [
          { required: true, message: '请输入检查所见', trigger: 'blur' }
        ],
        wyg: [
          { required: true, message: '请输入诊断所得', trigger: 'blur' }
        ],
        modality: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        bodyPart: [
          { required: true, message: '请输入模板分组', trigger: 'blur' }
        ]
      },
      debouncedGetAnswer: '',
      isReport: '1',
      flag: false,
      isChangeTemplate: false,
      renounceSave: false,
      showRejectReportDialog: false,
      rejectReportReason: ''
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.resizeHeight)
    window.addEventListener('resize', this.resizeWidth)
  },
  created() {
    this.$store.dispatch('getReportVariable').then(() => {})
    this.ReportInfo(this.ReportVariable.procedureId)
    if (this.ReportVariable.type === '1') {
      this.isReport = '1'
      this.search.CompleteStatus = '5'
    } else {
      this.search.CompleteStatus = '25'
      this.isReport = '2'
    }
    this.getChecktype()
    this.resizeHeight()
    this.resizeWidth()
    this.getPdfPrintTemplateList()
    // this.debouncedGetAnswer = this.lodash.debounce(this.debounce, 3000)
    this.checkTimeType(this.timeType)
    this.submit()
  },
  computed: {
    ...mapGetters([
      'writeReportList',
      'printInfo',
      'dict',
      'templates',
      'savemodulestatus',
      'ReportVariable',
      'checkList',
      'printList',
      'departId',
      'name',
      'currentUserRoleDepart',
      'lock',
      'roles'
    ]),
    newdeviceType() {
      return this.search.Modality
    },
    templateDevice() {
      return this.saveModule.modality
    },
    newWys() {
      return this.printInfo.wys
    },
    newWyg() {
      return this.printInfo.wyg
    },
    newisPositive() {
      return this.printInfo.isPositive
    },
    newisEmergency() {
      return this.printInfo.isEmergency
    }
  },
  methods: {
    renderContent(h, { node, data, store }) {
      if (data.templateId) {
        return (
          <span class='custom-tree-node' style='width:100%;'>
            <i class='el-icon-document'></i>
            <span style='margin-left:5px;'>{data.templateDircName}</span>
          </span>
        )
      } else {
        return (
          <span class='custom-tree-node'>
            <span>{node.label}</span>
          </span>
        )
      }
    },
    renderSelfContent(h, { node, data, store }) {
      if (data.templateId) {
        return (
          <span class='custom-tree-node' style='width:100%;'>
            <el-popover trigger='hover' placement='left'>
              <el-button size='mini' type='text' on-click={ () => this.deleteSelfTemplate(node, data) }><i class='el-icon-delete'></i>删除</el-button>
              <div slot='reference' class='name-wrapper'>
                <i class='el-icon-document'></i>
                <span style='margin-left:5px;'>{data.templateDircName}</span>
              </div>
            </el-popover>
          </span>
        )
      } else {
        return (
          <span class='custom-tree-node'>
            <span>{node.label}</span>
          </span>
        )
      }
    },
    deleteSelfTemplate(node, data) {
      this.$confirm('是否确定删除模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.treeLoading = true
        const request = { templateId: data.templateId }
        this.$store
          .dispatch('deleteUserReportTemplate', request)
          .then(() => {
            this.treeLoading = false
            this.ifSelfTemplate = true
            this.gettemplate()
            this.$message({ message: '删除个人模板成功！', type: 'success' })
          })
          .catch(() => {
            this.treeLoading = false
            this.$message({ message: '删除个人模板失败！', type: 'error' })
          })
      })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.templateDircName.indexOf(value) !== -1
    },
    changeTemplate(val, data, self) {
      this.isChangeTemplate = true
      if (val.templateId) {
        this.$store
          .dispatch('getTemplateInfo', { dircId: val.templateDircId, wordBar: this.wordBar })
          .then(() => {
          })
          .catch(() => {})
      }
    },
    resizeHeight() {
      this.tableHeight = document.documentElement.clientHeight - 283 + 'px'
      this.printHeight = document.documentElement.clientHeight - 105
      this.treeHeight = document.documentElement.clientHeight - 86 - 48 - 280 - 60
    },
    resizeWidth() {
      this.centerWidth = document.documentElement.clientWidth - 566
    },
    checkTimeType(type) {
      if (type === 0) {
        this.search.DateArray = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 1) {
        this.search.DateArray = [new Date(new Date() - 3600 * 1000 * 24), new Date()]
      }
      if (type === 2) {
        this.search.DateArray = [new Date(new Date() - 3600 * 1000 * 24 * 3), new Date()]
      }
      if (type === 3) {
        this.search.DateArray = [new Date(new Date() - 3600 * 1000 * 24 * 7), new Date()]
      }
    },
    getBody(value) {
      if (value) {
        var temp = ''
        for (let i = 0; i < this.checkList.checkType.length; i++) {
          if (this.checkList.checkType[i].name === value) {
            temp = this.checkList.checkType[i].modality
            break
          }
        }
        this.$store.dispatch('getcheckBody', { departId: this.departId, modality: temp }).then(() => { // 提交登记
        }).catch(() => {
          this.$message({ message: '获取检查部位失败，请重新获取', type: 'warning' })
        })
      }
    },
    getChecktype() {
      this.$store.dispatch('getcheckType', { departId: this.departId }).then(() => { // 提交登记
      }).catch(() => {
        this.$message({ message: '获取设备类型失败，请重新获取', type: 'error' })
      })
    },
    getPdfPrintTemplateList() {
      this.$store.dispatch('getPdfPrintTemplateList').then(() => { // 模板列表
        if (this.printList.length > 0) {
          this.reportModule = this.printList[0].templateId
        }
      }).catch(() => {
        this.$message({ message: '获取模板列表失败!', type: 'error' })
      })
    },
    printReport(patientNo) {
      if (!patientNo) {
        patientNo = ''
      }
      if (this.reportModule) {
        window.open(this.$getCfg('VUE_APP_BASE_API') + '/common/getreportpdf?reportId=' + this.printInfo.reportId + '&templateId=' + this.reportModule + '&fileName=' + patientNo, '_blank')
      } else {
        this.$message({ message: '请选择打印模板!', type: 'error' })
      }
    },
    submit: function() {
      this.loading = true
      this.tableLoading = true
      if (this.search.CompleteStatus === '5' || this.search.CompleteStatus === '25') {
        this.search.IsShowAll = 1
      } else {
        this.search.IsShowAll = 0
      }
      if (this.queryType === 0) {
        this.search.PatientName = ''
        this.search.PerformNo = this.queryValue
      } else {
        this.search.PerformNo = ''
        this.search.PatientName = this.queryValue
      }
      this.$store
        .dispatch('GetReportList', this.search)
        .then(() => {
          this.loading = false
          this.tableLoading = false
          this.fullloading = false
        })
        .catch(() => {
          this.tableLoading = false
          this.loading = false
          this.fullloading = false
        })
    },
    ReportInfo: function(datas) { // 获取报告信息
      this.fullloading = true
      this.$store
        .dispatch('GetReportByProcedureId', datas)
        .then(() => {
          this.changeTemplateType()
          this.loading = false
          this.printLoading = false
          this.fullloading = false
        })
        .catch(() => {
          this.changeTemplateType()
          this.printLoading = false
          this.loading = false
          this.fullloading = false
        })
    },
    dbTalble: function(row, event) {
      var vm = this
      this.loading = true
      this.printLoading = true
      this.$store
        .dispatch('getLock', {
          procedureId: row.procedureId,
          departId: this.currentUserRoleDepart.departId
        })
        .then(() => {
          if (vm.lock.data) {
            if (vm.isReport === '1') {
              sessionStorage.setItem('setReportVariable', JSON.stringify({ procedureId: row.procedureId, type: '1' })) // 添加到sessionStorage
              vm.$store.dispatch('getReportVariable').then(() => {})
              if (row.status === 50) {
                vm.NewReport(row)
              } else {
                vm.ReportInfo(vm.ReportVariable.procedureId)
              }
            } else {
              sessionStorage.setItem('setReportVariable', JSON.stringify({ procedureId: row.procedureId, type: '2' })) // 添加到sessionStorage
              vm.$store.dispatch('getReportVariable').then(() => {})
              if (row.status === 80) {
                vm.BeginApproveReport(row)
              } else {
                vm.ReportInfo(vm.ReportVariable.procedureId)
              }
            }
          } else {
            vm.loading = false
            vm.printLoading = false
            vm.$message({ message: vm.lock.message, type: 'success' })
          }
        })
        .catch(() => {
          vm.loading = false
          vm.printLoading = false
          vm.$message({ message: vm.lock.message, type: 'success' })
        })
    },
    NewReport: function(row) { // 初次保存状态为50/80时
      var CreateOrUpdateReport = {// 保存更新报告
        reportId: row.reportId,
        performId: row.performId,
        regId: row.regId,
        wys: row.wys,
        wyg: row.wyg,
        status: row.status,
        isEmergency: row.isEmergency,
        isPositive: row.isPositive,
        procedureIds: row.procedureIds,
        isDeleted: false,
        departId: row.departId,
        qcScore: row.qcScore
      }
      this.$store
        .dispatch('NewReport', CreateOrUpdateReport)
        .then(() => {
          this.ReportInfo(this.ReportVariable.procedureId)
          this.changeTemplateType()
          this.submit()
        })
        .catch(() => {
          this.fullloading = false
          this.loading = false
          this.printLoading = false
        })
    },
    BeginApproveReport: function(row) { // 初次保存状态为50/80时
      var CreateOrUpdateReport = {// 保存更新报告
        reportId: row.reportId,
        performId: row.performId,
        regId: row.regId,
        wys: row.wys,
        wyg: row.wyg,
        status: row.status,
        isEmergency: row.isEmergency,
        isPositive: row.isPositive,
        procedureIds: row.procedureIds,
        isDeleted: false,
        departId: row.departId,
        qcScore: row.qcScore
      }
      this.$store
        .dispatch('BeginApproveReport', CreateOrUpdateReport)
        .then(() => {
          this.ReportInfo(this.ReportVariable.procedureId)
          this.changeTemplateType()
          this.submit()
        })
        .catch(() => {
          this.fullloading = false
          this.loading = false
          this.printLoading = false
        })
    },
    // debounce: function() {
    //   if (!this.renounceSave) {
    //     if (this.isReport === '1') {
    //       if (this.printInfo.status < 61) {
    //         this.debouncedGetAnswer = this.lodash.debounce(this.debounce, 3000)
    //         this.AutoSaveReport(60)
    //       } else {
    //         this.flag = false
    //         this.debouncedGetAnswer = ''
    //       }
    //     } else {
    //       if (this.printInfo.status > 60 && this.printInfo.status < 91) {
    //         this.debouncedGetAnswer = this.lodash.debounce(this.debounce, 3000)
    //         this.AutoSaveReport(90)
    //       } else {
    //         this.flag = false
    //         this.debouncedGetAnswer = ''
    //       }
    //     }
    //   }
    // },
    AutoSaveReport: function() { // 自动保存
      this.loading = true
      this.CreateOrUpdateReport = {
        reportId: this.printInfo.reportId,
        performId: this.printInfo.performId,
        regId: this.printInfo.regId,
        wys: this.printInfo.wys,
        wyg: this.printInfo.wyg,
        status: this.printInfo.status,
        isEmergency: this.printInfo.isEmergency,
        isPositive: this.printInfo.isPositive,
        procedureIds: this.printInfo.procedureIds,
        isDeleted: false,
        departId: this.printInfo.departId,
        qcScore: this.printInfo.qcScore
      }
      this.$store
        .dispatch('AutoSaveReport', this.CreateOrUpdateReport)
        .then(() => {
          this.submit()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    SubmitReport: function() { // 提交
      this.loading = true
      if (this.printInfo.wys === null && this.printInfo.wys === null) {
        this.$confirm('您还未做完诊断，是否继续提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.CreateOrUpdateReport = {
            reportId: this.printInfo.reportId,
            performId: this.printInfo.performId,
            regId: this.printInfo.regId,
            wys: this.printInfo.wys,
            wyg: this.printInfo.wyg,
            status: this.printInfo.status,
            isEmergency: this.printInfo.isEmergency,
            isPositive: this.printInfo.isPositive,
            procedureIds: this.printInfo.procedureIds,
            isDeleted: false,
            departId: this.printInfo.departId,
            qcScore: this.printInfo.qcScore
          }
          this.$store
            .dispatch('SubmitReport', this.CreateOrUpdateReport)
            .then(() => {
              this.$message({ message: '您已成功提交诊断！', type: 'success' })
              this.submit()
            })
            .catch(() => {
              this.loading = false
            })
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.CreateOrUpdateReport = {
          reportId: this.printInfo.reportId,
          performId: this.printInfo.performId,
          regId: this.printInfo.regId,
          wys: this.printInfo.wys,
          wyg: this.printInfo.wyg,
          status: this.printInfo.status,
          isEmergency: this.printInfo.isEmergency,
          isPositive: this.printInfo.isPositive,
          procedureIds: this.printInfo.procedureIds,
          isDeleted: false,
          departId: this.printInfo.departId,
          qcScore: this.printInfo.qcScore
        }
        this.$store
          .dispatch('SubmitReport', this.CreateOrUpdateReport)
          .then(() => {
            this.$message({ message: '您已成功提交诊断！', type: 'success' })
            this.BeginApproveReport()
            this.submit()
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    DeleteReport: function() {
      this.loading = true
      this.CreateOrUpdateReport = {
        reportId: this.printInfo.reportId,
        performId: this.printInfo.performId,
        regId: this.printInfo.regId,
        wys: this.printInfo.wys,
        wyg: this.printInfo.wyg,
        status: this.printInfo.status,
        isEmergency: this.printInfo.isEmergency,
        isPositive: this.printInfo.isPositive,
        procedureIds: this.printInfo.procedureIds,
        isDeleted: false,
        departId: this.printInfo.departId,
        qcScore: this.printInfo.qcScore
      }
      this.$store
        .dispatch('DeleteReport', this.CreateOrUpdateReport)
        .then(() => {
          this.$message({ message: '您已成功放弃诊断！', type: 'success' })
          if (this.isReport === '1') {
            this.$router.push({ path: 'diagnostic/index' })
          } else {
            this.$router.push({ path: 'audit/index' })
            return false
          }
          this.submit()
        })
        .catch(() => {
          this.loading = false
        })
    },
    SubmitApproveReport: function() { // 审核
      this.loading = true
      this.CreateOrUpdateReport = {
        reportId: this.printInfo.reportId,
        performId: this.printInfo.performId,
        regId: this.printInfo.regId,
        wys: this.printInfo.wys,
        wyg: this.printInfo.wyg,
        status: this.printInfo.status,
        isEmergency: this.printInfo.isEmergency,
        isPositive: this.printInfo.isPositive,
        procedureIds: this.printInfo.procedureIds,
        isDeleted: false,
        departId: this.printInfo.departId,
        qcScore: this.printInfo.qcScore
      }
      this.$store
        .dispatch('SubmitApproveReport', this.CreateOrUpdateReport)
        .then(() => {
          this.$message({ message: '您已成功提交审核！', type: 'success' })
          this.submit()
        })
        .catch(() => {
          this.loading = false
        })
    },
    AbandonApproveReport() {
      this.loading = true
      this.CreateOrUpdateReport = {
        reportId: this.printInfo.reportId,
        performId: this.printInfo.performId,
        regId: this.printInfo.regId,
        wys: this.printInfo.wys,
        wyg: this.printInfo.wyg,
        status: this.printInfo.status,
        isEmergency: this.printInfo.isEmergency,
        isPositive: this.printInfo.isPositive,
        procedureIds: this.printInfo.procedureIds,
        isDeleted: false,
        departId: this.printInfo.departId,
        qcScore: this.printInfo.qcScore
      }
      this.$store
        .dispatch('AbandonApproveReport', this.CreateOrUpdateReport)
        .then(() => {
          this.$message({ message: '您已成功放弃审核！', type: 'success' })
          if (this.isReport === '1') {
            this.$router.push({ path: 'diagnostic/index' })
          } else {
            this.$router.push({ path: 'audit/index' })
            return false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    RejectReport() {
      this.loading = true
      this.CreateOrUpdateReport = {
        reportId: this.printInfo.reportId,
        performId: this.printInfo.performId,
        regId: this.printInfo.regId,
        wys: this.printInfo.wys,
        wyg: this.printInfo.wyg,
        status: this.printInfo.status,
        isEmergency: this.printInfo.isEmergency,
        isPositive: this.printInfo.isPositive,
        procedureIds: this.printInfo.procedureIds,
        isDeleted: false,
        departId: this.printInfo.departId,
        qcScore: this.printInfo.qcScore,
        rejectReason: this.rejectReportReason
      }
      this.$store
        .dispatch('RejectReport', this.CreateOrUpdateReport)
        .then(() => {
          this.$message({ message: '您已成功驳回报告！', type: 'success' })
          if (this.isReport === '1') {
            this.$router.push({ path: 'diagnostic/index' })
          } else {
            this.$router.push({ path: 'audit/index' })
            return false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    savemodule: function() {
      this.$refs['saveModule'].validate((valid) => {
        if (valid) {
          this.treeLoading = true
          this.$store
            .dispatch('PostModule', this.saveModule)
            .then(() => {
              this.saveTemplate = false
              this.treeLoading = false
              this.ifSelfTemplate = true
              this.gettemplate()
              this.$message({ message: '保存个人模板成功！', type: 'success' })
            })
            .catch(() => {
              this.treeLoading = false
              this.saveTemplate = false
              this.$message({ message: '保存个人模板失败！', type: 'error' })
            })
        } else {
          return false
        }
      })
    },
    gettemplate: function() {
      this.treeLoading = true
      this.$store
        .dispatch('getTemplate', { reportId: this.printInfo.reportId, templateType: this.modules, departId: this.printInfo.departId })
        .then(() => {
          this.treeLoading = false
        })
        .catch(() => {
          this.treeLoading = false
        })
    },
    changeTemplateType: function() {
      if (this.modules === 'GlobalTemplate') {
        this.gettemplate()
        this.filterText = ''
        this.ifSelfTemplate = false
      } else {
        this.filterText = ''
        this.ifSelfTemplate = true
        this.gettemplate()
      }
    },
    returnPrev: function() {
      if (this.printInfo.status === 60 || this.printInfo.status === 90) {
        if (this.isReport === '1') {
          if (this.printInfo.status === 60) {
            this.$confirm('是否确定放弃诊断，并退出当前报告？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.DeleteReport(50, true, '您已成功放弃诊断')
            }).catch(() => {
              if (this.$route.query.isconsultation) {
                this.$router.push({ path: 'consultation/index' })
              } else {
                this.$router.push({ path: 'diagnostic/index' })
              }
            })
          }
          if (this.printInfo.status === 90) {
            this.$confirm('是否确定放弃审核，并退出当前报告？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.AbandonApproveReport(80, true, '您已成功放弃审核')
            }).catch(() => {
              if (this.$route.query.isconsultation) {
                this.$router.push({ path: 'consultation/index' })
              } else {
                this.$router.push({ path: 'diagnostic/index' })
              }
            })
          }
        } else {
          this.$confirm('是否确定放弃审核，并退出当前报告？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.AbandonApproveReport(80, true, '您已成功放弃审核')
          }).catch(() => {
            this.$router.push({ path: 'audit/index' })
          })
        }
      } else if (this.printInfo.status !== 60 && this.printInfo.status !== 90) {
        if (this.isReport === '1') {
          if (this.$route.query.isconsultation) {
            this.$router.push({ path: 'consultation/index' })
          } else {
            this.$router.push({ path: 'diagnostic/index' })
          }
        } else {
          this.$router.push({ path: 'audit/index' })
        }
      }
    },
    patientDetails: function() {
      window.open(this.$getCfg('VUE_APP_BASE_HOST') + '/#/Registration/patient?regId=' + this.printInfo.regId, '_blank', 'height=900, width=1300, top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes')
    },
    recordDetails: function() {
      window.open(this.$getCfg('VUE_APP_BASE_HOST') + '/#/Diagnostic/stateRecord?reportId=' + this.printInfo.reportId, '_blank', 'height=900, width=1300, top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes')
    },
    historyDetails: function() {
      window.open(this.$getCfg('VUE_APP_BASE_HOST') + '/#/Diagnostic/historyReport?reportId=' + this.printInfo.reportId, '_blank', 'height=900, width=1300, top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes')
    },
    pacsImg: function(url) {
      window.open(url, 'pacsImg', 'top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes')
    },
    weasisImg: function(url) {
      window.open(url, '_blank')
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val)
    },
    saveTemplate(val) {
      if (val) {
        this.saveModule = {
          templateId: '',
          hospId: this.currentUserRoleDepart.hospId,
          departId: this.printInfo.departId,
          name: '',
          reportId: this.printInfo.reportId,
          modality: this.printInfo.modalityName,
          bodyPart: this.printInfo.bodyParts,
          doctorAdvice: this.name,
          isPositive: 0,
          gender: 0,
          wyg: this.printInfo.wyg,
          wys: this.printInfo.wys
        }
      } else {
        this.$refs['saveModule'].resetFields()
      }
    },
    // newWys(val) {
    //   if (this.printInfo.status < 61) {
    //     this.debouncedGetAnswer()
    //   } else if (this.printInfo.status > 70 && this.printInfo.status < 91) {
    //     this.debouncedGetAnswer()
    //   }
    // },
    // newWyg(val) {
    //   if (this.printInfo.status < 61) {
    //     if (!this.isChangeTemplate) {
    //       this.debouncedGetAnswer()
    //     } else {
    //       this.isChangeTemplate = false
    //     }
    //   } else if (this.printInfo.status > 70 && this.printInfo.status < 91) {
    //     if (!this.isChangeTemplate) {
    //       this.debouncedGetAnswer()
    //     } else {
    //       this.isChangeTemplate = false
    //     }
    //   }
    // },
    // newisPositive(val) {
    //   if (this.printInfo.status < 61) {
    //     this.debouncedGetAnswer()
    //   } else if (this.printInfo.status > 70 && this.printInfo.status < 91) {
    //     this.debouncedGetAnswer()
    //   }
    // },
    // newisEmergency(val) {
    //   if (this.printInfo.status < 61) {
    //     this.debouncedGetAnswer()
    //   } else if (this.printInfo.status > 70 && this.printInfo.status < 91) {
    //     this.debouncedGetAnswer()
    //   }
    // },
    newdeviceType(val) {
      this.search.bodyPart = ''
      this.getBody(this.search.Modality)
    },
    templateDevice() {
      this.search.bodyPart = ''
      this.getBody(this.saveModule.modality)
    },
    timeType(type) {
      this.checkTimeType(type)
    },
    queryType(val) {
      if (val === 0) {
        this.search.PerformNo = this.queryValue
      } else {
        this.search.PatientName = this.queryValue
      }
    }
  },
  filters: {
    // 年龄
    ageFilter: function(age) {
      return age
    },
    checkItemFilter: function(datas) {
      if (datas.length > 0) {
        var arr = datas
        var resultarr = [...new Set(arr)]
        var arrs = resultarr.join(',')
        return arrs
      } else {
        var str = ''
        return str
      }
    },
    checkingItems(datas) {
      if (datas) {
        if (datas.length > 11) {
          datas = datas.slice(0, 10) + '…'
        }
        return datas
      } else {
        return ''
      }
    }
  }
}
</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.writereport{
  overflow: hidden;
}
.main {
  min-height: calc(100vh - 110px);
  position: relative;
  overflow: hidden;
  .main-cont {
    min-height: calc(100vh - 110px);
    position: relative;
    overflow: hidden;
    border-top: 2px solid #dddDDD;
    .main-left {
      min-height: calc(100vh - 110px);
      width: 300px;
      float: left;
      background: #f8f8f8;
      border-right:1px solid #ddd;
      @media screen and (max-width: 880px) {
        width: 100%;
        float: left;
      }
    }
    .main-right {
      min-height: calc(100vh - 100px);
      width: 266px;
      float: right;
      border-left:1px solid #ddd;
      background: #f8f8f8;
      @media screen and (max-width: 880px) {
        width: 100%;
        float: left;
      }
      .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
        margin-bottom: 10px;
      }
    }
    .main-center {
      min-height: calc(100vh - 110px);
      float: left;
      text-align: center;
      overflow-x: auto;
      overflow-y: hidden;
      @media screen and (max-width: 880px) {
        float: left;
        width: 100% !important;
        height: auto !important;
      }
    }
    .filter-tree {
      min-height: 94%;
      background: #f8f8f8;
    }
    .right-btn {
      text-align: center;
    }
    .right-tree {
      overflow-y: auto;
      background: #fff;
    }
    .div_prints {
      text-align: left;
    }
    .el-textarea {
      height: auto;
    }
    .writeport_image {
      padding-left: 10px;
      padding-right: 10px;
    }
    .div_prints_table {
      padding: 10px;
      width: 100%;
      border-bottom: 1px solid #ddd;
    }
    .div_prints_footer {
      height: 40px;
      line-height: 20px;
      padding: 10px;
      span {
        width: 25%;
        float: left;
      }
    }
  }
  .el-row {
    margin-left: 0;
    margin-right: 0;
  }
  .left-module {
    padding-top: 10px;
  }
  .center-module {
    width: 794px;
    overflow-y: auto;
    display: inline-block;
    @media screen and (max-width: 880px) {
      float: left;
      width: 100% !important;
      height: auto !important;
    }
  }
  .right-module {
    padding-bottom: 10px;
    .right-btn{
      .el-button--mini, .el-button--mini.is-round {
        padding: 7px 11px;
        margin: 1px;
      }
    }
  }
  .right-title {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 100%;
    font-size: 14px;
    margin-right: 10px;
    padding-left: 10px;
    color: #3A4A64;
    border-bottom: 1px solid #DDDDDD;
  }
  .el-table__body-wrapper {
    min-height: calc(100vh - 341px) !important;
  }
  .right-form{
    padding: 10px;
  }
}
.writereport-header {
  height: 80px;
  line-height: 80px;
  margin-bottom: 20px;
  background: #f8f8f8;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  .header-return {
    position: absolute;
  }
  .header-father-list {
    list-style: none;
    height: 80px;
    line-height: 80px;
    margin: 0px;
    padding: 0px;
    display: inline-block;
    li {
      float: left;
      width: 6em;
    }
  }
  .header-child-list {
    cursor: pointer;
    list-style: none;
    height: 80px;
    padding: 0;
    :first-child {
      height: 40px;
      width: 100%;
      text-align: center;
    }
    :last-child {
      height: 40px;
      width: 100%;
      line-height: 40px;
      text-align: center;
    }
    .svg-icon {
      width: 30px;
      color: #3e89e5;
    }
  }
}
.el-select {
  width: 100%;
}
.fix-btn{
  position: fixed;
  bottom: 60px;
  right:335px;
  .el-button.is-round{
    padding: 10px 10px !important;
  }
}

</style>

